/**
 * What a store app needs from the web app, mounted once inside the router:
 * - a link to the site that opens the app (the magic link,
 *   https://chouette.memoneo.app/auth/verify?token=…, a shared story) is
 *   followed inside the app;
 * - Android's back button goes back, and leaves the app on the first page;
 * - the splash screen stays until the app has drawn its first page.
 * Renders nothing, and does nothing in a browser. Copied from Empilo.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { App } from "@capacitor/app";
import { SplashScreen } from "@capacitor/splash-screen";
import { SystemBars, SystemBarsStyle } from "@capacitor/core";
import { isNative } from "./platform";

export default function NativeShell() {
  const navigate = useNavigate();
  useEffect(() => {
    if (!isNative()) return;
    void SystemBars.setStyle({ style: SystemBarsStyle.Dark });
    void SplashScreen.hide();
    const opened = App.addListener("appUrlOpen", ({ url }) => {
      const link = new URL(url);
      navigate(link.pathname + link.search + link.hash);
    });
    const back = App.addListener("backButton", ({ canGoBack }) => {
      if (canGoBack) window.history.back();
      else void App.exitApp();
    });
    return () => {
      void opened.then((l) => l.remove());
      void back.then((l) => l.remove());
    };
  }, [navigate]);
  return null;
}
